import initialState from '../initialState';
import _ from 'lodash';
import * as types from './actionTypes.projectAnalytics';

let initialStateObj = {
    projectsAnalytics: initialState.projectsAnalytics,
};

export default function ProjectAnalyticsReducer(state = initialStateObj, action) {
    let reports, reportIndex, report;
    switch (action.type) {
        case types.GET_ANALYTICS_REPORTS_OK:
            return {
                ...state,
                ...{
                    projectsAnalytics: {
                        ...state.projectsAnalytics, ...{
                            [action.projectId]: {
                                ...state.projectsAnalytics[action.projectId],
                                reports: [...action.reports],
                                settings: { ...action.settings },
                            }
                        }
                    }
                },
            };

        case types.GET_DATA_BY_REPORT_OK:
            reports = [...state.projectsAnalytics[action.projectId]?.reports || []];
            reportIndex = _.findIndex(reports, { name: action.reportName });
            report = { ...reports[reportIndex], data: action.data, };
            reports[reportIndex] = report;
            return {
                ...state,
                ...{
                    projectsAnalytics: {
                        ...state.projectsAnalytics, ...{
                            [action.projectId]: {
                                ...state.projectsAnalytics[action.projectId],
                                reports: [...reports],
                            }
                        }
                    }
                },
            };

        case types.GET_PARTIAL_DATA_BY_REPORT_OK:
            reports = [...state.projectsAnalytics[action.projectId]?.reports || []];
            reportIndex = _.findIndex(reports, { name: action.reportName });
            report = { ...reports[reportIndex], data: { ...reports[reportIndex].data, ...action.data }, };
            reports[reportIndex] = report;
            return {
                ...state,
                ...{
                    projectsAnalytics: {
                        ...state.projectsAnalytics, ...{
                            [action.projectId]: {
                                ...state.projectsAnalytics[action.projectId],
                                reports: [...reports],
                            }
                        }
                    }
                },
            };


        case types.TOGGLE_REPORT_SECTION_OK:
            return {
                ...state,
                ...{
                    projectsAnalytics: {
                        ...state.projectsAnalytics, ...{
                            [action.projectId]: {
                                ...state.projectsAnalytics[action.projectId],
                                settings: { ...action.settings },
                            }
                        }
                    }
                },
            };

        case types.ADD_ANALYTICS_REPORT_REQ:
        case types.RENAME_ANALYTICS_REPORT_REQ:
        case types.DELETE_ANALYTICS_REPORT_REQ:
            return {
                ...state,
                ...{
                    projectsAnalytics: {
                        ...state.projectsAnalytics, ...{
                            [action.projectId]: {
                                ...state.projectsAnalytics[action.projectId],
                                blockingActionInProcess: true,
                            }
                        }
                    }
                },
            };

        case types.CHANGE_ANALYTICS_PERIOD_REPORT_FILTER_OK:
            reports = [...state.projectsAnalytics[action.projectId]?.reports || []];
            reportIndex = _.findIndex(reports, { name: action.reportName });
            report = { ...reports[reportIndex], data: action.data, period: action.period, ...action.dates, };
            reports[reportIndex] = report;
            return {
                ...state,
                ...{
                    projectsAnalytics: {
                        ...state.projectsAnalytics, ...{
                            [action.projectId]: {
                                ...state.projectsAnalytics[action.projectId],
                                reports: [...reports],
                            }
                        }
                    }
                },
            };

        case types.CHANGE_ANALYTICS_DATE_RANGE_REPORT_FILTER_OK:
            reports = [...state.projectsAnalytics[action.projectId]?.reports || []];
            reportIndex = _.findIndex(reports, { name: action.reportName });
            report = { ...reports[reportIndex], data: action.data, startTs: action.startTs, endTs: action.endTs, };
            reports[reportIndex] = report;
            return {
                ...state,
                ...{
                    projectsAnalytics: {
                        ...state.projectsAnalytics, ...{
                            [action.projectId]: {
                                ...state.projectsAnalytics[action.projectId],
                                reports: [...reports],
                            }
                        }
                    }
                },
            };

        case types.TOGGLE_SHOW_EVENTS_FILTER_FOR_PATTERN_FLOW_OK:
            reports = [...state.projectsAnalytics[action.projectId]?.reports || []];
            reportIndex = _.findIndex(reports, { name: action.reportName });
            report = { ...reports[reportIndex], data: action.data, onlyPatternOnPatternFlow: action.onlyPatternOnPatternFlow };
            reports[reportIndex] = report;
            return {
                ...state,
                ...{
                    projectsAnalytics: {
                        ...state.projectsAnalytics, ...{
                            [action.projectId]: {
                                ...state.projectsAnalytics[action.projectId],
                                reports: [...reports],
                            }
                        }
                    }
                },
            };

        case types.ADD_ANALYTICS_REPORT_OK:
            reports = [...state.projectsAnalytics[action.projectId]?.reports || []];

            return {
                ...state,
                ...{
                    projectsAnalytics: {
                        ...state.projectsAnalytics, ...{
                            [action.projectId]: {
                                ...state.projectsAnalytics[action.projectId],
                                reports: [
                                    ...reports,
                                    action.report
                                ],
                                blockingActionInProcess: false,
                            }
                        }
                    }
                },
            };

        case types.RENAME_ANALYTICS_REPORT_OK:
            reports = [...state.projectsAnalytics[action.projectId]?.reports || []];
            reportIndex = _.findIndex(reports, { name: action.reportName });
            report = { ...reports[reportIndex], name: action.newReportName };
            reports[reportIndex] = report;
            return {
                ...state,
                ...{
                    projectsAnalytics: {
                        ...state.projectsAnalytics, ...{
                            [action.projectId]: {
                                ...state.projectsAnalytics[action.projectId],
                                reports: [...reports],
                                blockingActionInProcess: false,
                            }
                        }
                    }
                },
            };

        case types.DELETE_ANALYTICS_REPORT_OK:
            reports = [...state.projectsAnalytics[action.projectId]?.reports || []];
            reportIndex = _.findIndex(reports, { name: action.reportName });
            reports.splice(reportIndex, 1);
            return {
                ...state,
                ...{
                    projectsAnalytics: {
                        ...state.projectsAnalytics, ...{
                            [action.projectId]: {
                                ...state.projectsAnalytics[action.projectId],
                                reports: [...reports],
                                blockingActionInProcess: false,
                            }
                        }
                    }
                },
            };

        case types.UPDATE_PATTERNS_IN_ANALYTICS_REPORT_OK:
        case types.UPDATE_INTENTS_IN_ANALYTICS_REPORT_OK:
            reports = [...state.projectsAnalytics[action.projectId]?.reports || []];
            reportIndex = _.findIndex(reports, { name: action.reportName });
            report = { ...reports[reportIndex], data: action.data };
            reports[reportIndex] = report;
            return {
                ...state,
                ...{
                    projectsAnalytics: {
                        ...state.projectsAnalytics, ...{
                            [action.projectId]: {
                                ...state.projectsAnalytics[action.projectId],
                                reports: [...reports],
                            }
                        }
                    }
                },
            };




        default:
            return state;
    }
}
